import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import View from '../View';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Div Block',
  showEmpty: true,
  style: {
    base: {
      main: {
        noPseudo: {
          flexBasis: px(800),
          flexGrow: 0,
          flexShrink: 1,
          marginRight: px(20),
        },
      },
      small: {
        noPseudo: {
          marginRight: px(0),
          flexBasis: 'auto',
        },
      },
    },
  },
  render: View,
  fields: {children: TListOfElement},
});

export default config;
